import { CommonModule } from '@angular/common';
import {
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  Output,
  SimpleChanges,
  ViewChild
} from '@angular/core';
import {
  FormGroup,
  FormsModule,
  ReactiveFormsModule
} from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelect, MatSelectModule } from '@angular/material/select';
import { NgxMatSelectSearchModule } from 'ngx-mat-select-search';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { OrdersListService } from '../../sales/order-list-components/order-list.service';
import { environment } from 'environments/environment.prod';
import { IRequestResult } from 'app/common/interfaces/request-result.interface';
import { MasterUserInterface, MasterUserPaginatedInterface } from '../../sales/order-generate/interfaces/master-user.interface';
import BusinessPartnerGroupAttributes from '@albatrosdeveloper/ave-models-package/lib/schemas/business-partners/business-partner-group/business-partner-group.entity';
import BusinessPartnerTypeAttributes from '@albatrosdeveloper/ave-models-package/lib/schemas/business-partners/business-partner-type/business-partner-type.entity';
import BusinessPartnerAttributes from '@albatrosdeveloper/ave-models-package/lib/schemas/business-partners/business-partner/business-partner.entity';
import { GetAllShipTosRequest, IGetAllSoldTosDto } from '../../business-partners/business-partner/interfaces/update-business-partner.interface';
import { BusinessPartnerService } from '../../business-partners/business-partner/business-partner.service';
import { getCode } from 'app/utils/method';
import { MatSnackBar } from '@angular/material/snack-bar';
import { IFilters } from '../interfaces/filterInterface';
import { UserMasterService } from '../../routing/sub-routes/sub-route-collaborator/user_master.service';

@Component({
  selector: 'app-business-partners-filters',
  standalone: true,
  imports: [
    CommonModule,
    MatFormFieldModule,
    MatSelectModule,
    FormsModule,
    ReactiveFormsModule,
    NgxMatSelectSearchModule,
    MatButtonModule,
    MatIconModule
  ],
  templateUrl: './business-partners-filters.component.html',
  styleUrl: './business-partners-filters.component.scss'
})
export class BusinessPartnersFiltersComponent {

  constructor(
    private readonly ordersListService: OrdersListService,
    private userMasterService: UserMasterService,
    private readonly businessPartnerService: BusinessPartnerService,
    private snackBar: MatSnackBar,
    private cdr: ChangeDetectorRef
  ) {
  }
  getCode = getCode;
  @Input() form!: FormGroup;
  @Input() businessGroupList: BusinessPartnerGroupAttributes[] = [];
  @Input() businessGroupWithMongoId: boolean = false;
  @Input() businessPartnerRolList: BusinessPartnerTypeAttributes[] = [];
  @Input() businessPartnerTypeList: BusinessPartnerTypeAttributes[] = [];
  @Input() businessPartnerFilterList: BusinessPartnerAttributes[] = []
  @Input() businessPartnerFilter: boolean = false;
  @Input() businessPartner: boolean = false;
  @Input() businessPartnerWithMongoId: boolean = false;
  @Input() payingBusinessPartner: boolean = false;
  @Input() receivingBusinessPartner: boolean = false;
  @Input() assignedUser: boolean = false;
  @Input() solicitedUser: boolean = false;
  @Input() assignedUserByBusinessPartnerId: boolean = false;
  @Input() assignedUserByBusinessPartnerName: boolean = false;
  @Input() assignedUserWithMongoId: boolean = false;
  @Input() loadData: boolean = undefined;

  @Output() groupChanged = new EventEmitter<void>();

  @ViewChild(MatSelect, { static: false }) public matSelect: MatSelect;

  searchBusinessPartenertGroup = '';
  searchBusinessPartenert = '';
  searchPayingBusinessPartner = '';
  searchReceivingBusinessPartner = '';
  searchAssignedUser = '';

  filteredBusinessGroupList: BusinessPartnerGroupAttributes[] = [];

  originalPayingBusinessPartnerList: BusinessPartnerAttributes[] = [];
  payingBusinessPartnerList: BusinessPartnerAttributes[] = [];

  receivingBusinessPartnerList: BusinessPartnerAttributes[] = [];
  filteredReceivingBusinessPartnerList: BusinessPartnerAttributes[] = [];

  originalAssignedUserList: MasterUserPaginatedInterface[] = [];
  filteredAssignedUserList: MasterUserPaginatedInterface[] = [];

  originalAssignedUserWithMongoList: BusinessPartnerAttributes[] = [];
  filteredAssignedUserWithMongoList: BusinessPartnerAttributes[] = [];

  originalBusinessPartnerList: BusinessPartnerAttributes[] = [];
  businessPartnerList: BusinessPartnerAttributes[] = [];
  filteredBusinessPartnerList: BusinessPartnerAttributes[] = [];

  ngOnInit() {
    if (this.loadData === undefined) {
      this.loadAllData();
    }
  }

  private loadAllData(): void {
    if (this.payingBusinessPartnerList) this.initPayingBusinessPartnerList();
    if (this.assignedUser || this.assignedUserByBusinessPartnerId || this.assignedUserByBusinessPartnerName || this.solicitedUser) this.initListSeller();
    if (this.assignedUserWithMongoId) this.findAllBusinessPartnerWithCount();
    if (this.receivingBusinessPartner) this.initListShipTo();
    if (this.businessPartner || this.businessPartnerWithMongoId) this.getAllBusinessPartnerInit();
  }

  initListShipTo(search?): void {
    let dataToSend: GetAllShipTosRequest = {
      companyIds: [environment.companyId],
      search: search?.toString() || ''
    }

    this.ordersListService.fetchShipTos(dataToSend).subscribe((res) => {
      this.receivingBusinessPartnerList = res?.data;
      this.filteredReceivingBusinessPartnerList = res?.data;
    })
  }

  private getAllBusinessPartnerInit(): void {
    const materialOptions = {
      search: "",
      currentPage: 1,
      limitPerPage: 50,
      sortActive: "name",
    };

    this.businessPartnerService
      .findToComboBoxCustomer(
        materialOptions,
        [],
        []
      )
      .subscribe({
        next: (res: IRequestResult<BusinessPartnerAttributes[]>) => {
          this.businessPartnerList = res?.data ?? [];
          this.filteredBusinessPartnerList = res?.data ?? [];
        },
        error: (err) => {
          this.snackBar.open(err.error.message || "Error al obtener socios de negocios.", "Cerrar", { duration: 5000 });
        },
      });
  }

  filterReceivingBusinessPartner(search: string): void {
    const selectedIds = this.form.get('receivingBusinessPartnerId')?.value || [];
    const value = search?.toLowerCase() ?? '';

    const dataToSend: GetAllShipTosRequest = {
      companyIds: [environment.companyId],
      search: search?.toString() || ''
    };

    this.ordersListService.fetchShipTos(dataToSend).subscribe((res) => {
      const news = res?.data ?? [];

      const mapaForId = new Map<string, BusinessPartnerAttributes>();

      this.receivingBusinessPartnerList.forEach(item => {
        mapaForId.set(item._id.toString(), item);
      });

      news.forEach(item => {
        mapaForId.set(item._id.toString(), item);
      });

      this.receivingBusinessPartnerList = Array.from(mapaForId.values());

      const seleccionados = this.receivingBusinessPartnerList.filter(item => selectedIds.includes(item.id));
      const noSeleccionados = this.receivingBusinessPartnerList.filter(item => !selectedIds.includes(item.id));
      const ordenada = [...seleccionados, ...noSeleccionados];

      if (value === '') {
        this.filteredReceivingBusinessPartnerList = ordenada;
      } else {
        this.filteredReceivingBusinessPartnerList = ordenada.filter(item =>
          item.name?.toLowerCase().includes(value) || item.externalKeys?.code?.toLowerCase().includes(value)
        );
      }

      this.receivingBusinessPartnerList = ordenada;

      this.cdr.detectChanges();
    });
  }

  private initListSeller() {
    let options = {
      currentPage: 1,
      limitPerPage: 50,
      search: null,
      sort: "username"
    };

    this.userMasterService.getAllPaginateAllUsers(options).subscribe({
      next: (res) => {
        this.originalAssignedUserList = res.data;
        this.filteredAssignedUserList = res.data;
      },
      error: (err) => {
        this.snackBar.open(
          err.error.message || "Error al obtener usuarios",
          "Cerrar",
          { duration: 5000 }
        );
      },
    });
  }

  filterAssignedUserBybusinessPartnerId(search: string): void {
    const selectedIds = (this.form.get('assignedUserId')?.value || []).map((id) => id.toString());
    const value = search?.toLowerCase() ?? '';

    const dataToSend = {
      currentPage: 1,
      limitPerPage: 50,
      search: search?.toString() || '',
      sort: "username"
    };

    this.userMasterService.getAllPaginateAllUsers(dataToSend).subscribe({
      next: (res) => {
        const news = res?.data ?? [];

        const mapaForId = new Map<string, MasterUserPaginatedInterface>();


        this.originalAssignedUserList.forEach(item => {
          mapaForId.set(item.user_login_id.toString(), item);
        });

        news.forEach(item => {
          mapaForId.set(item.user_login_id.toString(), item);
        });


        this.originalAssignedUserList = Array.from(mapaForId.values());


        const seleccionados = this.originalAssignedUserList.filter(item => selectedIds.includes(item.business_partner_id));
        const noSeleccionados = this.originalAssignedUserList.filter(item => !selectedIds.includes(item.business_partner_id));
        const ordenada = [...seleccionados, ...noSeleccionados];

        if (value === '') {
          this.filteredAssignedUserList = ordenada;
        } else {
          this.filteredAssignedUserList = ordenada.filter(item =>
            item.user_login_first_name?.toLowerCase().includes(value)
          );
        }

        this.cdr.detectChanges();
      },
      error: (err) => {
        this.snackBar.open(
          err.error.message || "Error al obtener usuarios",
          "Cerrar",
          { duration: 5000 }
        );
      },
    });
  }

  filterAssignedUserByUserName(search: string): void {
    const selectedIds = (this.form.get('assignedUserId')?.value || []).map((id) => id.toString());
    const value = search?.toLowerCase() ?? '';

    const dataToSend = {
      currentPage: 1,
      limitPerPage: 50,
      search: search?.toString() || '',
      sort: "username"
    };

    this.userMasterService.getAllPaginateAllUsers(dataToSend).subscribe({
      next: (res) => {
        const news = res?.data ?? [];

        const mapaForId = new Map<string, MasterUserPaginatedInterface>();


        this.originalAssignedUserList.forEach(item => {
          mapaForId.set(item.user_login_id.toString(), item);
        });

        news.forEach(item => {
          mapaForId.set(item.user_login_id.toString(), item);
        });


        this.originalAssignedUserList = Array.from(mapaForId.values());


        const seleccionados = this.originalAssignedUserList.filter(item => selectedIds.includes(item.user_login_username));
        const noSeleccionados = this.originalAssignedUserList.filter(item => !selectedIds.includes(item.user_login_username));
        const ordenada = [...seleccionados, ...noSeleccionados];

        if (value === '') {
          this.filteredAssignedUserList = ordenada;
        } else {
          this.filteredAssignedUserList = ordenada.filter(item =>
            item.user_login_first_name?.toLowerCase().includes(value)
          );
        }

        this.cdr.detectChanges();
      },
      error: (err) => {
        this.snackBar.open(
          err.error.message || "Error al obtener usuarios",
          "Cerrar",
          { duration: 5000 }
        );
      },
    });
  }

  filterAssignedUserByFirstName(search: string): void {
    const selectedIds = (this.form.get('assignedUserId')?.value || []).map((id) => id.toString());
    const value = search?.toLowerCase() ?? '';

    const dataToSend = {
      currentPage: 1,
      limitPerPage: 50,
      search: search?.toString() || '',
      sort: "username"
    };

    this.userMasterService.getAllPaginateAllUsers(dataToSend).subscribe({
      next: (res) => {
        const news = res?.data ?? [];

        const mapaForId = new Map<string, MasterUserPaginatedInterface>();


        this.originalAssignedUserList.forEach(item => {
          mapaForId.set(item.user_login_id.toString(), item);
        });

        news.forEach(item => {
          mapaForId.set(item.user_login_id.toString(), item);
        });


        this.originalAssignedUserList = Array.from(mapaForId.values());


        const seleccionados = this.originalAssignedUserList.filter(item => selectedIds.includes(item.user_login_first_name));
        const noSeleccionados = this.originalAssignedUserList.filter(item => !selectedIds.includes(item.user_login_first_name));
        const ordenada = [...seleccionados, ...noSeleccionados];

        if (value === '') {
          this.filteredAssignedUserList = ordenada;
        } else {
          this.filteredAssignedUserList = ordenada.filter(item =>
            item.user_login_first_name?.toLowerCase().includes(value)
          );
        }

        this.cdr.detectChanges();
      },
      error: (err) => {
        this.snackBar.open(
          err.error.message || "Error al obtener usuarios",
          "Cerrar",
          { duration: 5000 }
        );
      },
    });
  }

  initPayingBusinessPartnerList(search?): void {
    let dataToSend: IGetAllSoldTosDto = {
      companyIds: [environment.companyId],
      search: search?.toString() || ''
    }
    this.ordersListService.fetchSoldTos(dataToSend).subscribe((res) => {
      this.originalPayingBusinessPartnerList = [...res?.data];
      this.payingBusinessPartnerList = [...res?.data];
    })
  }

  getListSoldTo(search?: string): void {
    const selectedIds = this.form.get('payingBusinessPartnerId')?.value || [];
    const value = search?.toLowerCase() ?? '';

    const dataToSend: IGetAllSoldTosDto = {
      companyIds: [environment.companyId],
      search: search?.toString() || ''
    };

    this.ordersListService.fetchSoldTos(dataToSend).subscribe((res) => {
      const news = res?.data ?? [];

      const mapaForId = new Map<string, BusinessPartnerAttributes>();


      this.originalPayingBusinessPartnerList.forEach(item => {
        mapaForId.set(item._id.toString(), item);
      });

      news.forEach(item => {
        mapaForId.set(item._id.toString(), item);
      });


      this.originalPayingBusinessPartnerList = Array.from(mapaForId.values());


      const seleccionados = this.originalPayingBusinessPartnerList.filter(item => selectedIds.includes(item.id));
      const noSeleccionados = this.originalPayingBusinessPartnerList.filter(item => !selectedIds.includes(item.id));
      const ordenada = [...seleccionados, ...noSeleccionados];

      if (value === '') {
        this.payingBusinessPartnerList = ordenada;
      } else {
        this.payingBusinessPartnerList = ordenada.filter(item =>
          item.name?.toLowerCase().includes(value) || item.externalKeys?.code?.toLowerCase().includes(value)
        );
      }

      this.cdr.detectChanges();
    });
  }

  filterPayingBusinessPartner(search: string): void {
    const value = search?.toLowerCase() ?? '';
    if (value === '') {
      this.payingBusinessPartnerList = [...this.originalPayingBusinessPartnerList];
    } else {
      this.payingBusinessPartnerList = this.originalPayingBusinessPartnerList.filter(item =>
        item.name?.toLowerCase().includes(value)
      );
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['businessGroupList']) {
      this.filteredBusinessGroupList = [...this.businessGroupList];
    }
    if (changes['businessPartnerFilterList']) {
      this.filteredBusinessPartnerList = [...this.businessPartnerFilterList];
      if (this.businessGroupList.length) this.filterBusinessPartnerByGroup('');
    }
    if (changes['businessPartnerList']) {
      this.filteredBusinessPartnerList = [...this.businessPartnerList];
    }
    if (changes['receivingBusinessPartnerList']) {
      this.filteredReceivingBusinessPartnerList = [...this.receivingBusinessPartnerList];
    }

    if (changes['loadData'] && changes['loadData'].currentValue === true) {
      this.loadAllData();
    }
  }

  fetchGroup(): void {
    const selectedGroups = this.form.get('businessPartnerGroupId')?.value;
    if (selectedGroups?.length && this.businessPartnerFilter) {
      this.groupChanged.emit();
    }
  }

  filterBusinessPartnerGroup(search: string): void {
    const value = search?.toLowerCase() ?? '';
    if (value === '') {
      this.filteredBusinessGroupList = this.businessGroupList;
    } else {
      this.filteredBusinessGroupList = this.businessGroupList.filter(item =>
        item.name?.toLowerCase().includes(value) || item.externalKeys?.code?.toLowerCase().includes(value)
      );
    }
    this.cdr.detectChanges();
  }

  filterBusinessPartnerByGroup(search: string) {
    const selectedGroups = this.form.get('businessPartnerGroupId')?.value;
    const options = {
      search: search || '',
      currentPage: 1,
      limitPerPage: 50,
      sortActive: "name",
      groupIds: selectedGroups
    };

    this.businessPartnerService
      .findToComboBoxMultipleBP(
        options,
        (this.businessPartnerFilterList || []).map(bp => String(bp._id)),
        [],
        {
          groupIds: selectedGroups,
          businessGroupWithMongoId: this.businessGroupWithMongoId ? true : false
        }
      )
      .subscribe({
        next: (res: IRequestResult<BusinessPartnerAttributes[]>) => {
          this.businessPartnerList = res?.data ?? [];
          this.filteredBusinessPartnerList = res?.data ?? [];
        },
        error: (err) => {
          this.snackBar.open(err.error.message || 'Error al obtener socios de negocios filtrados', 'Cerrar', { duration: 3000 });
        },
      });
  }

  filterBusinessPartner(search: string): void {
    const selectedIds = this.form.get('customerId')?.value || [];
    const value = search?.toLowerCase() ?? '';

    if (!value) {
      const seleccionados = this.businessPartnerList.filter(item => selectedIds.includes(item.id));
      const noSeleccionados = this.businessPartnerList.filter(item => !selectedIds.includes(item.id));
      const ordenada = [...seleccionados, ...noSeleccionados];

      this.filteredBusinessPartnerList = ordenada;
      this.businessPartnerList = ordenada;

      this.cdr.detectChanges();
      return;
    }

    const materialOptions = {
      search: search || '',
      currentPage: 1,
      limitPerPage: 50,
      sortActive: "name",
    };

    this.businessPartnerService
      .findToComboBoxCustomer(
        materialOptions,
        [],
        []
      )
      .subscribe((res: any) => {
        const news = res?.data ?? [];

        const mapaForId = new Map<string, BusinessPartnerAttributes>();

        this.businessPartnerList.forEach(item => {
          mapaForId.set(item._id.toString(), item);
        });

        news.forEach(item => {
          mapaForId.set(item._id.toString(), item);
        });


        this.businessPartnerList = Array.from(mapaForId.values());


        const seleccionados = this.businessPartnerList.filter(item => selectedIds.includes(item.id));
        const noSeleccionados = this.businessPartnerList.filter(item => !selectedIds.includes(item.id));
        const ordenada = [...seleccionados, ...noSeleccionados];

        if (value === '') {
          this.filteredBusinessPartnerList = ordenada;
        } else {
          this.filteredBusinessPartnerList = ordenada.filter(item =>
            item.name?.toLowerCase().includes(value) || item.externalKeys?.code?.toLowerCase().includes(value)
          );
        }

        this.businessPartnerList = ordenada;
        this.cdr.detectChanges();
      });
  }

  findAllBusinessPartnerWithCount(): void {
    let filter: IFilters = {
      typeCustomer: ['BPT0003', 'BPT0002']
    };

    this.businessPartnerService
      .findAllWithCount(
        {
          currentPage: 1,
          limitPerPage: 50,
          sort: "_id",
          sortDirection: "ASC",
        },
        false,
        [],
        "both",
        filter
      )
      .subscribe((data) => {

        this.originalAssignedUserWithMongoList = data?.data?.[0]?.data ?? [];
        this.filteredAssignedUserWithMongoList = data?.data?.[0]?.data ?? [];
      });
  }


  filterBusinessPartnerWithCount(search: string): void {
    const selectedIds = this.form.get('customerId')?.value || [];
    const value = search?.toLowerCase() ?? '';

    if (!value) {
      const seleccionados = this.originalAssignedUserWithMongoList.filter(item => selectedIds.includes(item.id));
      const noSeleccionados = this.originalAssignedUserWithMongoList.filter(item => !selectedIds.includes(item.id));
      const ordenada = [...seleccionados, ...noSeleccionados];

      this.filteredAssignedUserWithMongoList = ordenada;
      this.originalAssignedUserWithMongoList = ordenada;

      this.cdr.detectChanges();
      return;
    }

    let filter: IFilters = {
      typeCustomer: ['BPT0003', 'BPT0002']
    };

    this.businessPartnerService
      .findAllWithCount(
        {
          currentPage: 1,
          limitPerPage: 50,
          sort: "_id",
          sortDirection: "ASC",
          search: search
        },
        false,
        [],
        "both",
        filter
      )
      .subscribe((data) => {
        const news = data?.data?.[0]?.data ?? [];

        const mapaForId = new Map<string, BusinessPartnerAttributes>();

        this.originalAssignedUserWithMongoList.forEach(item => {
          mapaForId.set(item._id.toString(), item);
        });

        news.forEach(item => {
          mapaForId.set(item._id.toString(), item);
        });


        this.originalAssignedUserWithMongoList = Array.from(mapaForId.values());


        const seleccionados = this.originalAssignedUserWithMongoList.filter(item => selectedIds.includes(item.id));
        const noSeleccionados = this.originalAssignedUserWithMongoList.filter(item => !selectedIds.includes(item.id));
        const ordenada = [...seleccionados, ...noSeleccionados];

        if (value === '') {
          this.filteredAssignedUserWithMongoList = ordenada;
        } else {
          this.filteredAssignedUserWithMongoList = ordenada.filter(item =>
            item.name?.toLowerCase().includes(value) || item?.externalKeys?.code?.toLowerCase().includes(value)
          );
        }

        this.originalAssignedUserWithMongoList = ordenada;
        this.cdr.detectChanges();
      });
  }

  getDisplayValueForMongoId(list: BusinessPartnerAttributes[] | MasterUserInterface[], ids: string[], field: string): string {
    if (Array.isArray(ids)) {
      return list
        .filter(item => ids.includes(item._id.toString()))
        .map(item => item?.[field] ?? '')
        .join(', ');
    } else {
      const found = list.find(item => item._id === ids);
      return found?.[field] ?? '';
    }
  }

  getDisplayValueMasterUserForMongoId(list: MasterUserPaginatedInterface[], ids: string[], field: string): string {
    if (Array.isArray(ids)) {
      return list
        .filter(item => ids.includes(item.user_login_id.toString()))
        .map(item => item?.[field] ?? '')
        .join(', ');
    } else {
      const found = list.find(item => item.user_login_id === ids);
      return found?.[field] ?? '';
    }
  }

  getDisplayValueForId(list: BusinessPartnerAttributes[] | BusinessPartnerGroupAttributes[], ids: number[], field: string): string {
    if (Array.isArray(ids)) {
      return list
        .filter(item => ids.includes(item.id))
        .map(item => item?.[field] ?? '')
        .join(', ');
    } else {
      const found = list.find(item => item.id === ids);
      return found?.[field] ?? '';
    }
  }

  getDisplayValueForUserName(list: MasterUserPaginatedInterface[], ids: string[], field: string): string {
    if (Array.isArray(ids)) {
      return list
        .filter(item => ids.includes(item.user_login_username) || ids.includes(item.business_partner_id) || ids.includes(item.user_login_first_name))
        .map(item => item?.[field] ?? '')
        .join(', ');
    } else {
      const found = list.find(item => item.user_login_username === ids || item.business_partner_id === ids || item.user_login_first_name === ids);
      return found?.[field] ?? '';
    }
  }

  getDisplayValueForCode(list: BusinessPartnerTypeAttributes[], ids: string[], field: string): string {
    if (Array.isArray(ids)) {
      return list
        .filter(item => ids.includes(item.code))
        .map(item => item?.[field] ?? '')
        .join(', ');
    } else {
      const found = list.find(item => item.code === ids);
      return found?.[field] ?? '';
    }
  }

  clearBusinessPartnerGroup(): void {
    this.form.get('businessPartnerGroupId')?.setValue([]);
    this.searchBusinessPartenertGroup = '';
    this.filteredBusinessGroupList = [...this.businessGroupList];
  }

  clearBusinessPartnerRol(): void {
    this.form.get('businessPartnerRolId')?.setValue([]);
  }

  clearBusinessPartnerType(): void {
    this.form.get('businessPartnerTypeId')?.setValue([]);
  }

  clearCustomerId(): void {
    this.form.get('customerId')?.setValue([]);
    this.searchBusinessPartenert = '';
    this.filteredBusinessPartnerList = [...this.businessPartnerList];
  }

  clearPayingBusinessPartner(): void {
    this.form.get('payingBusinessPartnerId')?.setValue([]);
    this.searchPayingBusinessPartner = '';
    this.payingBusinessPartnerList = [...this.originalPayingBusinessPartnerList];
  }

  clearReceivingBusinessPartner(): void {
    this.form.get('receivingBusinessPartnerId')?.setValue([]);
    this.searchReceivingBusinessPartner = '';
    this.filteredReceivingBusinessPartnerList = [...this.receivingBusinessPartnerList];
  }

  clearAssignedUser(): void {
    this.form.get('assignedUserId')?.setValue([]);
    this.searchAssignedUser = '';
    if (this.assignedUserWithMongoId) {
      this.filteredAssignedUserWithMongoList = [...this.originalAssignedUserWithMongoList];
    } else {
      this.filteredAssignedUserList = [...this.originalAssignedUserList];
    }
  }
}
